const reportResult = [
	{ text: 'Fight No', value: 'fight_no' ,sortable: false},
	{ text: 'Group No', value: 'group_no' ,sortable: false},
	{ text: 'Result Name', value: 'name' ,sortable: false},
	{ text: 'Date Time', value: 'date' ,sortable: false},
];

export default reportResult;